import { Injectable } from '@angular/core';

import { Attribute } from '@shared/models/attribute';
import { ItemAttributeAssignment } from '@shared/models/item-attribute-assignment';
import { comparator } from '@shared/utils/comparator';

@Injectable()
export class ItemAttributeAssignmentsSortingService {
  /**
   * Sorts the assignments based on the order of item attributes.
   * Sorting will be made based on the order of provided item attributes.
   * The sorting is not made based on 'Order' property of item attribute to avoid the need to
   * change logic here if ordering (asc, desc) of item attributes changes in the future.
   */
  sort(
    assignments: ItemAttributeAssignment[],
    attributes: Attribute[]
  ): ItemAttributeAssignment[] {
    return [...assignments].sort(
      (a: ItemAttributeAssignment, b: ItemAttributeAssignment) => {
        const valueA = this.sortAccessor(a, attributes);
        const valueB = this.sortAccessor(b, attributes);

        return comparator(valueA, valueB);
      }
    );
  }

  /**
   * Sort by order in the item attributes instead of order property
   */
  private sortAccessor(
    assignment: ItemAttributeAssignment,
    attributes: Attribute[]
  ): number {
    return attributes?.findIndex(x => x.id === assignment.attributeId);
  }
}
